import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { UPGRADE_PAGE } from 'ui-addon-upgrades/_core/common/constants/PurchaseMotionLocations';
import SkeletonLoadWrapper from '../../components/common/loading/SkeletonLoadWrapper';
import SuiteTileCTAsContainer from '../../components/merch-card/SuiteTileCTAsContainer';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';

// This is actually returning a seats interstital button, which sends the user to the seats interstitial page.
// An actual checkout button is on the interstitial page.
import { jsx as _jsx } from "react/jsx-runtime";
const CrmSuiteStarterCheckoutButton = ({
  trackingSource,
  ctaStyles
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: [47],
    children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
      productLevel: STARTER,
      trackingSource: trackingSource,
      ctaStyles: ctaStyles,
      returnFirstCTAOnly: true,
      isFreeToStarter: true,
      location: UPGRADE_PAGE
    })
  });
};
export default CrmSuiteStarterCheckoutButton;